import axiosApiClient from "../axios";

const PATH = '/api/guardian';

export const getAllGuardians = async () => {
    return await axiosApiClient.get(PATH);
};

export const getGuardianByUserName = async (username) => {
    return await axiosApiClient.get(`${PATH}/${username}/username`);
};

export const getGuardianById = async (guardianId) => {
    return await axiosApiClient.get(`${PATH}/${guardianId}`);
};

export const getGuardianDetailById = async (guardianId) => {
    return await axiosApiClient.get(`${PATH}/${guardianId}/detail`);
};

export const addGuardian = async guardian => {
    try {
        return await axiosApiClient.post(PATH, guardian, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Add Guardian failed');
    }
};

export const deleteGuardian = async (guardianId) => {
    try {
        return await axiosApiClient.delete(`${PATH}/${guardianId}`);
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Delete Guardian failed');
    }
};

export const updateGuardian = async (guardianId, guardian) => {
    try {
        return await axiosApiClient.put(`${PATH}/${guardianId}`, guardian, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Update Guardian failed');
    }
};

